export const socialsData = {
    github: 'https://github.com/masham04',
    facebook: 'https://www.facebook.com/muhammad.masham.1',
    linkedIn: 'https://www.linkedin.com/in/muhammad-masham-915298172/',
    instagram: 'https://www.instagram.com/masham_302/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/Masham83711098',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}